import { useDispatch, useSelector } from "react-redux";
import OrderBasic from "./order.basic";
import Col from "../../../components/element/col";
import Container from "../../../components/element/container";
import { Skeleton } from "primereact/skeleton";
import useWindowDimension from "../../../components/hook/use.window.dimension";

export default function OrderList() {
  const dispatch = useDispatch();
  const { width } = useWindowDimension();
  const { orderList, orderListLoading } = useSelector((state) => state.order);

  return (
    <Container className="order-list">
      <Col className="v-flex w-100">
        {orderListLoading
          ? Array.from({ length: 3 }, (_, orderLoadingIndex) => (
              <Skeleton
                width="100%"
                height={width < 750 ? "68px" : "80px"}
                className="mb-4"
                key={orderLoadingIndex}
              />
            ))
          : orderList?.length > 0 &&
            orderList.map((order, orderIndex) => (
              <OrderBasic order={order} key={orderIndex} />
            ))}
      </Col>
    </Container>
  );
}
